import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { Col } from '@/components/Col'
import { FormItem } from '@/components/FormItem'
import { Row } from '@/components/Row'
import { errorMessage } from '@/components/Message'
import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { useForm } from '@/hooks/useForm'

import { Button, Form, Input, PasswordInput, Typography } from '../AuthComponents'
interface LoginFormProps {
  email: string
  password: string
  remember: boolean
}

export const I18N_PREFIX = 'pages.auth.loginForm'

export default function LoginPage() {
  const { t } = useTranslation()
  const form = useForm<LoginFormProps>()
  const { login, loading, error } = useCognitoAuth()

  function isValidForm() {
    const fieldErrors = form.getFieldsError().filter(({ errors }) => errors.length > 0)

    return fieldErrors.length === 0
  }

  const handleFormSubmit = (values: LoginFormProps) => {
    if (!isValidForm()) return

    login(values.email, values.password)
  }

  useEffect(() => {
    if (error?.message) {
      errorMessage(error.message)
    }
  }, [error])

  return (
    <>
      <Typography.Title>{t(`${I18N_PREFIX}.title`)}</Typography.Title>
      <Typography.Text>{t(`${I18N_PREFIX}.description`)}</Typography.Text>

      <Form
        form={form}
        name="loginForm"
        layout="vertical"
        initialValues={{ remember: true }}
        validateTrigger="onBlur"
        onFinish={handleFormSubmit}
        scrollToFirstError
        requiredMark={false}
      >
        <FormItem label={t(`${I18N_PREFIX}.userLabel`)} name="email" validation="email">
          <Input
            size="large"
            prefix={<UserOutlined />}
            placeholder={t(`${I18N_PREFIX}.userPlaceholder`)}
          />
        </FormItem>
        <FormItem label={t(`${I18N_PREFIX}.passwordLabel`)} name="password" validation="required">
          <PasswordInput
            size="large"
            prefix={<LockOutlined />}
            placeholder={t(`${I18N_PREFIX}.passwordPlaceholder`)}
          />
        </FormItem>
        <FormItem>
          <Row justify="end">
            <Col>
              <Link to="/auth/forgot">{t(`${I18N_PREFIX}.forgotPassword`)}</Link>
            </Col>
          </Row>
        </FormItem>

        <FormItem>
          <Button type="primary" htmlType="submit" block loading={loading} size="large">
            {t(`${I18N_PREFIX}.submitButton`)}
          </Button>
        </FormItem>
      </Form>
    </>
  )
}
